const accordions = document.querySelectorAll(".accordion");

if ( accordions && accordions.length > 0 ) {
    accordions.forEach(accordion => {
        const button = accordion.querySelector(".accordion-button");
        const content = accordion.querySelector(".accordion-content");
        const links = content.querySelectorAll("a");
        const svg = button.querySelector("svg");

        const close = () => {
            content.classList.remove("!grid-rows-[1fr]");
            accordion.classList.remove("open");
            svg?.classList.remove("rotate-180");
            document.removeEventListener("click", closeOutSide);
        }

        const closeOutSide = (e) => {
            if ( !accordion.contains(e.target) ) close();
        }

        const open = () => {
            content.classList.add("!grid-rows-[1fr]");
            accordion.classList.add("open");
            document.addEventListener("click", closeOutSide);
            svg?.classList.add("rotate-180");
        }

        button.addEventListener("click", () => {
            if ( accordion.classList.contains("open") ) {
                close()
            }
            else {
                accordion.classList.add("open");
                open()
            }
        })

        // window.addEventListener("resize", () => {
        //     links.forEach(item => item.classList.remove("hidden", "active"));
        // })
        //
        links.forEach(link => {
            link.addEventListener("click", () => {
                // links.forEach(item => item.classList.remove("active", "hidden"));
                // link.classList.add("active", "hidden");
                // button.querySelector("span").textContent = link.textContent;
                close()
            })
        })
    })
}